module.exports = __webpack_public_path__ + "img/wabo_logo.eb92cd65.jpg";